import React, { useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import Multiselect from "../Multiselect";
import Tag from "./Tag";
import { makeApiCall } from "../../config";

const subList = (title, text) => {
  return (
    <p className="mb-4 my-1 text-sm">
      {title} - <span className="font-bold text-gray-600">{text}</span>
    </p>
  );
};


const Accordion = ({
  index,
  icon,
  url,
  titleLists,
  pageInfo,
  handleChange,
  pageTitle,
  hostname,
  pathname,
  handleMultiSelect,
  multiSelect,
  ...prop
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [eventData, setEventData] = useState([]);

  const toggleAccordion = async(id) => {
    if (!isOpen) {
      try {
        const {code, message, data} = await makeApiCall(`/api/v1/admin/get/event/${id}`, 'get');
        if (code) {
          setIsOpen(true);
          setEventData(data);
        }
      } catch (error) {
        console.log("error occurred in toggle accordion", error);
      }
    }else{
      setIsOpen(false);
    }
  };
  return (
    <div className="my-6 w-full">
      <div className="relative p-3 flex flex-col rounded-2xl border border-gray-200 bg-white shadow-md">
        <div className="flex items-center">
          <div className="rounded-full bg-lightPrimary p-3">
            <span className="flex items-center text-[#51119F]">
              {icon}
            </span>
          </div>
          <div className="ml-4 flex-1">
            <input
              className="w-full max-w-3/4 bg-transparent"
              type="text"
              name={`${url}_title`}
              onChange={(e) => handleChange(e, index)}
              placeholder="Enter your own title"
              value={pageTitle}
              id="page-title"
            />
          </div>
          <div
            onClick={() => toggleAccordion(prop._id)}
            className={`cursor-pointer transition-transform ${isOpen ? "rotate-90" : ""}`}
          >
            <IoIosArrowForward />
          </div>
        </div>
        <div className="h-50 ml-4 flex w-auto flex-col justify-center">
          <h4 className="font-bold text-navy-700 dark:text-white flex">
            {subList("Domain", hostname)}
          </h4>
          {subList("Environment", prop.environment)}
          {subList("URL", url)}
          {subList("Events", prop.totalEvents)}
          {subList("Last Updated", prop.timeStamp)}
          <Multiselect placeholder={'Choose children for this page'} selectDefault={multiSelect} index={index} titleLists={titleLists?.filter((val)=> val.value !== pageTitle)} handleChange={handleMultiSelect} />
        </div>
        {isOpen && (
          <div className="p-4 rounded-b-[10px] bg-[#ffffffbc] border-gray-200 dark:border-gray-700 dark:bg-gray-900">
            <div className="mb-2 mx-3 text-gray-500 dark:text-gray-400">
              { eventData.length !==0 && eventData.map((item)=> <>
              { item.enable && (<Tag tags={item} title={item.text || "no text"} />) }
              </>)}
              {/* <Categories id={pageId} {...pageData} />
              {toggleFormList(formData, pageId)} */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Accordion;
